<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import ToggleSwitch from '@/components/ToggleSwitch.vue';
import PhasesAreasMenu from '@/components/menu/PhasesAreasMenu.vue';
import AreasMenu from '@/components/menu/AreasMenu.vue';
import WizardEventDispatcher from '@/components/wizard/WizardEventDispatcher.vue';

export default {
  template: '#site-header',
  components: {
    AreasMenu,
    PhasesAreasMenu,
    ToggleSwitch,
    WizardEventDispatcher
  },
  updated() {
    let title = document.title;
    if (this.phaseId && this.phases.length) {
      const phase = this.phases.find((p) => p.phaseId === this.phaseId);
      title = phase ? phase.name : title;
    }

    if (this.areaId && Object.keys(this.areas).length) {
      const area =
        this.areas[this.phaseId] &&
        this.areas[this.phaseId].find((a) => a.areaId === this.areaId);

      title = area ? `${title} | ${area.name}` : title;
    }

    document.title = title;
  },
  computed: {
    ...mapState({
      phases: (state) => state.general.phases,
      areaId: (state) => state.general.areaId,
      phaseId: (state) => state.general.phaseId
    }),

    areas(state) {
      const areas = _.get(this.$store.state, 'general.areas', []);

      if (!areas.length || state.phaseId === 'undefined') {
        return [];
      }

      return _.groupBy(areas, 'phaseId');
    },

    phases(state) {
      const areas = _.get(this.$store.state, 'general.areas', []);
      const phases = _.get(this.$store.state, 'general.phases', []);

      if (!areas.length || _.isEmpty(phases) || state.phaseId === 'undefined') {
        return [];
      }

      if (typeof state.areaId !== 'number') {
        // pro AreasMenu
        const nonEmptyPhaseId = Object.keys(_.groupBy(areas, 'phaseId'));
        return Object.values(_.pick(phases, nonEmptyPhaseId));
      }

      // pro PhasesAreasMenu
      const phasesByArea = _.groupBy(areas, 'areaId');

      if (!phasesByArea[state.areaId]) {
        return [];
      }

      return phasesByArea[state.areaId].map((area) => {
        return {
          ...area,
          name: phases[area.phaseId].name
        };
      });
    }
  }
};
</script>